import { Box, Fade, Modal, Stack, Typography } from "@mui/material";
import React from 'react';
import closeIcon from "../../../assets/images/close.svg";

const styleModal = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "420px",
    backgroundColor: "#1D292E",
    borderRadius: "8px",
    padding: "24px",
    boxShadow: "2px 2px 20px 2px #FFFFFF14"
};

interface ConfirmationModalProps {
    open: boolean;
    title: string;
    message: string;
    setConfirmation: (value: boolean) => void;
    setConfirmationModalOpen: (value: boolean) => void;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({ open, title, message, setConfirmation, setConfirmationModalOpen }) => {

    const handleConfirm = () => {
        setConfirmation(true);
        setConfirmationModalOpen(false)
    };
    
    const handleClose = () => {
        setConfirmationModalOpen(false)
    };

    return (
        <Modal
            open={open}
            onClose={handleClose}
            closeAfterTransition
            BackdropProps={{ timeout: 500 }}
        >
            <Fade in={open}>
                <Box sx={styleModal}>
                    <Stack direction="row" justifyContent="space-between" alignItems="center">
                        <Typography sx={{ color: '#E2E3E3', fontWeight: 500, fontSize: '20px' }}>
                            {title}
                        </Typography>
                        <img src={closeIcon} alt="close icon" onClick={handleClose} style={{ cursor: 'pointer' }} />
                    </Stack>
                    <Box sx={{ my: '16px', py: '16px', borderTop: '1px solid #313838' }}>
                        <Typography>{message}</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'end', gap: '12px' }}>
                        <Box 
                            sx={{minWidth: 70, textAlign: 'center', cursor: 'pointer', color: '#17B2EB', fontSize: '14px', fontWeight: 500, border: '1px solid #0B4A62', padding: '12px', borderRadius: '30px' }}
                            onClick={handleClose}
                        >
                            No
                        </Box>
                        <Box
                            sx={{minWidth: 70, textAlign: 'center', backgroundColor: '#17B2EB', padding: '12px', borderRadius: '30px', cursor: 'pointer', color: '#1E2121', fontSize: '14px', fontWeight: 500, margin:'0' }}
                            onClick={handleConfirm}
                        >
                            Yes
                        </Box>
                    </Box>
                </Box>
            </Fade>
        </Modal>
    );
};

export default ConfirmationModal;
